module.exports = __webpack_public_path__ + "img/Logo.e37f3b49.svg";